import React from "react";

const MainFooter = () => {
  return (
    
      <footer
        className="footer text-center text-lg-start bg-body-tertiary text-muted mt-auto"
      
      >
        <div
          className="text-center p-4"
          style={{ backgroundColor: "#ececec" }}
        >
          © {new Date().getFullYear()} Copyright{" "}
          <a className="text-reset fw-bold" href="https://lyricsweb.com/">
            Lyricsweb.com
          </a>
        </div>
      </footer>
  );
};

export default MainFooter;
